import React from 'react';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { useNavigate } from 'react-router-dom';

import { Button, Page } from '@occc-app/design-system';
import { clearFormField as clearFormFieldMutator } from '@occc-app/lib/finalFormUtils';

import { AudienceCreateFormRenderComponent } from './AudienceCreateFormRenderComponent';

import {
  AudienceFormInitialValues,
  AudienceFormProps,
  AudienceFormRenderProps,
  CreateAudiencePageProps,
  AudienceFormValues,
} from '../types';

export const AudienceCreatePage: React.FC<CreateAudiencePageProps> = ({
  initialValues,
  validate,
  audienceCreate,
  openAndScrollToInvalidSection,
}) => {
  const navigate = useNavigate();

  const renderForm: AudienceFormProps['render'] = React.useCallback(
    ({ form, handleSubmit, values, submitting }: AudienceFormRenderProps) => {
      return (
        <Page
          browserTabTitle='Create Audience'
          containerProps={{ variant: 'md' }}
          pageHeaderProps={{
            title: 'Audience Create',
            subtitle:
              'Create an audience to target members in your program based on demographics, preferences, store visits and purchase behaviour',
          }}
          actions={
            <>
              <Button variant='outlined' color='secondary' onClick={() => navigate(-1)}>
                Cancel
              </Button>
              <Button
                variant='contained'
                color='secondary'
                onClick={() => {
                  openAndScrollToInvalidSection(form);
                  handleSubmit();
                }}
                disabled={submitting}
                sx={{
                  ml: 1,
                }}
              >
                Save
              </Button>
            </>
          }
        >
          <AudienceCreateFormRenderComponent
            handleSubmit={handleSubmit}
            name={values.name}
            clearFormField={form.mutators.clearFormField}
          />
        </Page>
      );
    },
    [navigate, openAndScrollToInvalidSection],
  );

  return (
    <Form<AudienceFormValues, AudienceFormInitialValues>
      initialValues={initialValues}
      onSubmit={audienceCreate}
      render={renderForm}
      validate={validate}
      mutators={{ ...arrayMutators, clearFormField: clearFormFieldMutator }}
    />
  );
};
